import Image from "next/image";
import { useState } from "react";
import styled from "styled-components";
import {
  Container,
  ContainerContentStandard,
} from "../../../../shared/styles/container";
import { device } from "../../../../shared/styles/device";
import {
  TablistContainer,
  TablistWrapper,
  Tabnav,
  TabnavItems,
} from "../../../../shared/styles/tablist/tablist";

const NarrowContentWrapper = styled.div`
  max-width: 980px;
  margin: auto;

  .text-content {
    max-width: 768px;
    margin: auto;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 350px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 32px;

  @media ${device.tablet} {
    height: 550px;
  }
  img {
    border-radius: 16px;
  }
`;

const SpeedRecruitingContent = () => {
  return (
    <NarrowContentWrapper>
      <ImageWrapper>
        <Image
          src="/images/aboutus/_Ueber_uns_Speed-Recruitings.jpg"
          alt="Speed Recruiting Image"
          layout="fill"
          objectFit="cover"
          quality={100}
        />
      </ImageWrapper>
      <div className="text-content">
        <p>
          Seit 2012 organisieren wir unter der Marke STELL-MICH-EIN in ganz
          Deutschland Speed-Recruiting-Events in der Kommunikationsbranche.
          Dabei kommen Unternehmen und Bewerber*innen zusammen. Nun starten wir
          damit in der Touristik. Unser Speed-Recruiting hat mehrere Vorteile.
          Zum einen sparen teilnehmende Talente und Unternehmen unfassbar viel
          Zeit. Zum anderen sind diese Events sehr gute Netzwerkevents, die
          einen regelrechten Karriere-Boost für die Teilnehmer*innen mit sich
          bringen.
        </p>
      </div>
    </NarrowContentWrapper>
  );
};
const TalentpoolContent = () => {
  return (
    <NarrowContentWrapper>
      <ImageWrapper>
        <Image
          src="/images/talentpool/landingagentur/mac.png"
          alt="Talentpool Image"
          layout="fixed"
          height={560}
          width={960}
          objectFit="contain"
          quality={100}
        />
      </ImageWrapper>
      <div className="text-content">
        <p>
          Im Dezember 2022 startet auch unseren Talentpool. In dem digitalen
          Produkt sammeln wir talentierte Bewerber*innen, die sich für die
          Touristik begeistern. Unternehmen können einen kostenpflichtigen
          Zugang zum Talentpool erwerben und passende Kandidat*innen danach
          direkt kontaktieren. Vermittlungsgebühren fallen nicht an.
        </p>
      </div>
    </NarrowContentWrapper>
  );
};
const KampagnenContent = () => {
  return (
    <NarrowContentWrapper>
      <ImageWrapper>
        <Image
          src="/images/aboutus/_Ueber_uns_Education.jpg"
          alt="Speed Recruiting Image"
          layout="fill"
          objectFit="cover"
          quality={100}
        />
      </ImageWrapper>
      <div className="text-content">
        <p>
          easyboarding ist ein Gemeinschaftsprojekt aus starken Partnern. Wir
          besitzen Know-how in Weiterbildung, HR, Employer Branding und vor
          allem auch in der Touristik. Sehr gerne nehmen wir uns auch einzelnen
          Unternehmen an und entwickeln gemeinsam als Agentur individuelle
          Recruiting und Employer Branding-Lösungen.
        </p>
      </div>
    </NarrowContentWrapper>
  );
};
const KooperationenContent = () => {
  return (
    <NarrowContentWrapper>
      <ImageWrapper>
        <Image
          src="/images/aboutus/_Ueber_uns_Kooperationen.jpg"
          alt="Speed Recruiting Image"
          layout="fill"
          objectFit="cover"
          quality={100}
        />
      </ImageWrapper>
      <div className="text-content">
        <p>
          Unsere Events waren bereits zu Gast auf Kongressen, Messen und
          Konferenzen. Sehr gerne organisieren wir ein Recruiting-Event im
          Rahmen einer geplanten Veranstaltung der Touristik. Hast du Interesse
          an einer Kooperation, dann schreib uns gerne eine E-Mail.
        </p>
      </div>
    </NarrowContentWrapper>
  );
};
const KarrieretippsContent = () => {
  return (
    <NarrowContentWrapper>
      <ImageWrapper>
        <Image
          src="/images/aboutus/_Ueber_uns_JobNewsletter.jpg"
          alt="Speed Recruiting Image"
          layout="fill"
          objectFit="cover"
          quality={100}
        />
      </ImageWrapper>
      <div className="text-content">
        <p>
          Täglich versenden wir Newsletter. In diesen Newslettern verweisen wir
          auf diverse offene Stellen in der Touristik. Hier auf unserer Seite
          kannst du dich in den Newsletter eintragen. Möchtest du eine
          Stellenanzeige dort inserieren, dann melde dich gerne mit einer E-Mail
          bei uns.
        </p>
      </div>
    </NarrowContentWrapper>
  );
};

const JobboerseContent = () => {
  return (
    <NarrowContentWrapper>
      <ImageWrapper>
        <Image
          src="/images/recruiting/mac-jobs.png"
          alt="Jobboerse Image"
          layout="fixed"
          height={560}
          width={960}
          objectFit="cover"
          quality={100}
        />
      </ImageWrapper>
      <div className="text-content">
        <p>
          Unsere Jobbörse ist der ideale Orte, um Fachkräfte von der Junior-,
          bis zu einer Senior-Position zu finden. Der große Vorteil bei uns: Wir
          haben die große Branchenreichweite von TRVL Counter im Rücken.
          Jobanzeigen sind in einem täglichen Newsletter integriert, in ePapern,
          erscheinen auf Social Media und werden durch Social-Recruiting-Ads
          reichweitenstark an etwa 100.000 Kontakte ausgespielt.
        </p>
      </div>
    </NarrowContentWrapper>
  );
};

const AboutUsNodes = [
  {
    tabname: "Speed-Recruitings",
    contents: <SpeedRecruitingContent />,
  },
  {
    tabname: "Talentpool",
    contents: <TalentpoolContent />,
  },
  {
    tabname: "Jobbörse",
    contents: <JobboerseContent />,
  },
  {
    tabname: "Kampagnen",
    contents: <KampagnenContent />,
  },
  {
    tabname: "Kooperationen",
    contents: <KooperationenContent />,
  },
  {
    tabname: "Job-Newsletter",
    contents: <KarrieretippsContent />,
  },
];

export const TopicsTablist = () => {
  const [currentSelectedIndex, setCurrentSelectedIndex] = useState(0);
  const [topicBySelectedEvent, setTopics] = useState<any>(
    AboutUsNodes[0]?.contents
  );

  return (
    <section>
      <TablistContainer>
        <h2>Recruiting-Lösungen</h2>
        <p>Klick auf den jeweiligen Tab, um mehr zu erfahren.</p>
        <TablistWrapper>
          <Tabnav>
            <TabnavItems id="tablist-container" role="tablist">
              {AboutUsNodes?.map((node, index) => {
                return (
                  <li key={node.tabname} role="presentation">
                    <a
                      id={`${node.tabname}-tabnav-trigger`}
                      href={`#event-item-${node.tabname}`}
                      className={`${
                        currentSelectedIndex === index ? "current " : ""
                      }`}
                      role="tab"
                      tabIndex={currentSelectedIndex === index ? 0 : -1}
                      aria-selected={
                        currentSelectedIndex === index ? "true" : "false"
                      }
                      onClick={(event) => {
                        event.preventDefault();
                        setCurrentSelectedIndex(index);
                        setTopics(node.contents);
                        /*                                                 centerOnMobile(`${smeEvent.city}-tabnav-trigger`); */
                      }}
                    >
                      {node.tabname}
                    </a>
                  </li>
                );
              })}
            </TabnavItems>
          </Tabnav>
          <Container>
            <ContainerContentStandard>
              {topicBySelectedEvent}
            </ContainerContentStandard>
          </Container>
        </TablistWrapper>
      </TablistContainer>
    </section>
  );
};
